export default "__VITE_ASSET__BE4mgssY__"